import FinanceSerializer from './base';

export default class DailySummary extends FinanceSerializer {}
